import BASE_PATH from "../routing";

type WindowOpenHelpersArgs = {
  url: string;
  target?: string;
  features?: string;
};
const windowOpenHelper = (args: WindowOpenHelpersArgs) => {
  const { url, target = "_blank", features = "noopener,noreferrer" } = args;
  const destination = window.location.origin + BASE_PATH + url;
  return window.open(destination, target, features);
};

export default windowOpenHelper;
